module.exports = __webpack_public_path__ + "static/media/dot-bg.cd1f3fa6.svg";